export type WhiteboardMode = 'pencilMode' | 'magicpenMode' | 'erase' | 'text' | 'none';

export const RUBBER_SIZE = 30;
export const LINE_WIDTH_PENCIL = 4;
export const LINE_WIDTH_MAGICPEN = 7;

const ColorWhiteboardYellow = '#FFCF00';
const ColorWhiteboardOrange = '#FF9300';
const ColorWhiteboardRed = '#FF0000';
const ColorWhiteboardPink = '#FF00B8';
const ColorWhiteboardGreen = '#00E23C';
const ColorWhiteboardBlue = '#006BFF';
const ColorWhiteboardBlack = '#000000';

export const WhiteboardPenColors = {
  yellow: ColorWhiteboardYellow,
  orange: ColorWhiteboardOrange,
  red: ColorWhiteboardRed,
  pink: ColorWhiteboardPink,
  green: ColorWhiteboardGreen,
  blue: ColorWhiteboardBlue,
  black: ColorWhiteboardBlack,
};
